import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let calendar_date_user = new BaseTableModule('/ws/calendar_date_user/');

const state = {
    ...calendar_date_user.state,
    columns: [
        {text: 'User', value: 'human_user', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work to be, Σ=', value: 'work_to_be', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work as is, Σ=', value: 'work_as_is', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Payed, Σ=', value: 'payed', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Bonus, Σ=', value: 'extra_time', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Over time, Σ=', value: 'over_time', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Holiday, Σ=', value: 'holiday', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Holiday extra, Σ=', value: 'holiday_extra', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Sick, Σ=', value: 'sick', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Sick with child, Σ=', value: 'sick_with_child', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Sick kug, Σ=', value: 'sick_kug', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Public holiday', value: 'public_holiday', sortable: true, filterable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
};
const getters = {
    ...calendar_date_user.getters,
    getColumns(state) {
        // console.log('getColumns', state.columns, state.aggregateItemList)
        let resultColumns = []
        for (const item of state.columns) {
            if (item.value in state.aggregateItemList)
                item.text = item.text.replace(/Σ=.*/, 'Σ=' + state.aggregateItemList[item.value])
            resultColumns.push(item)
        }
        return resultColumns
    },
};
const actions = {
    ...calendar_date_user.actions,
};
const mutations = {
    ...calendar_date_user.mutations,
};

export default {
    modules: {
        CalendarDateUserStatisticRange: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}